import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaInstagram, FaFacebook, FaSquareXTwitter } from "react-icons/fa6";
import './Footer.css';
import logoImg from '../assets/edvergenceX2.png';

const Footer = () => {
    return (
        <footer className="landing-footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <div className="logo">
                            <Link to="/" aria-label="EdVergenceX Home">
                                <img src={logoImg} alt="EdVergenceX Logo" style={{ height: '50px', cursor: 'pointer' }} />
                            </Link>
                        </div>
                        <p>Bridging the gap between world-class industry leadership and academic excellence.</p>
                        <div className="social-links">
                            <a href="https://www.linkedin.com/company/EdVergenceX/about/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <FaLinkedin />
                            </a>
                            <a href="https://x.com/Ed_Practice" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                                <FaSquareXTwitter />
                            </a>
                            <a href="https://www.instagram.com/ed_professorofpractice/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <FaInstagram />
                            </a>
                            <a href="https://www.facebook.com/people/EdVergenceX/61586033878995/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <FaFacebook />
                            </a>
                        </div>
                    </div>

                    <div className="footer-links">
                        <h4>Platform</h4>
                        <Link to="/how-it-works">How It Works</Link>
                        <Link to="/institutions">For Institutions</Link>
                        <Link to="/professionals">For Professionals</Link>
                        <a href="https://purposefinder.ai/" target="_blank" rel="noopener noreferrer">
                            PurposeFinder AI
                        </a>
                        <a href="https://moonshotplanner.com/" target="_blank" rel="noopener noreferrer">
                            Moonshot Planner
                        </a>
                    </div>

                    <div className="footer-links">
                        <h4>Company</h4>
                        <Link to="/about">About Us</Link>
                        <Link to="/careers">Careers</Link>
                        <Link to="/pricing">Pricing</Link>
                    </div>

                    <div className="footer-links">
                        <h4>Support</h4>
                        <Link to="/help">Help Center</Link>
                        <Link to="/safety">Safety & Trust</Link>
                        <Link to="/contact">Contact Us</Link>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>© 2026 EdVergenceX - All rights reserved.</p>
                    <div className="footer-legal">
                        <Link to="/terms">Terms of Service</Link>
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/refund-policy">Refund Policy</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
